const SESSION_PATH = "/session";

export const isOnSessionPage = (): boolean =>
  typeof window !== "undefined" && window.location.pathname === SESSION_PATH;
